<template>
  <v-dialog :value="value" :width="400" @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="py-0">
        <v-btn flat icon left class="ml-auto" @click="$emit('input', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <iframe
        v-if="viewedItem()"
        :src="iframeUrl"
        frameborder="0"
        :style="{ width: '100%', height: '768px' }"
      ></iframe>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  inject: ['viewedItem', 'surveyId'],
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    iframeUrl() {
      const url =
        this.selectedBot.pageid === '450523781782424'
          ? 'https://survey.phyathai.zwiz.app'
          : 'https://develop.survey.phyathai.zwiz.app'
      return `${url}/?preview=true&page_id=${
        this.selectedBot.pageid
      }&survey_id=${this.surveyId()}&answer_id=${this.viewedItem().id}`
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/survey/Survey/SurveyViewDialog.vue